import { BookmarkBoxMultipleOutlineIcon } from './BookmarkBoxMultipleOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 1F563201-43D7-4CDA-8DB5-5F82A438965D
 * name bookmark-box-multiple-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-box-multiple-outline.svg
 * tags
 */
export const LibraryBookmarkOutlineIcon = BookmarkBoxMultipleOutlineIcon;
export default LibraryBookmarkOutlineIcon